import type { EditionColors } from "../types";

const DEFAULT_COLORS: EditionColors = {
  primary: "#F14E38",
  primaryForeground: "#FFFFFF",
  primaryAltOne: "#CD422F",
  primaryAltOneForeground: "#FFFFFF",
  primaryAltTwo: "#78271C",
  primaryAltTwoForeground: "#FFFFFF",
  primaryAltThree: "#A83526",
  primaryAltThreeForeground: "#FFFFFF",
};

export function injectTheme(
  colors: EditionColors | null | undefined,
  container: HTMLElement
) {
  const c = colors ?? DEFAULT_COLORS;

  container.style.setProperty("--festapp-primary", c.primary);
  container.style.setProperty("--festapp-primary-fg", c.primaryForeground);
  container.style.setProperty("--festapp-alt-1", c.primaryAltOne);
  container.style.setProperty("--festapp-alt-1-fg", c.primaryAltOneForeground);
  container.style.setProperty("--festapp-alt-2", c.primaryAltTwo);
  container.style.setProperty("--festapp-alt-2-fg", c.primaryAltTwoForeground);
  container.style.setProperty("--festapp-alt-3", c.primaryAltThree);
  container.style.setProperty("--festapp-alt-3-fg", c.primaryAltThreeForeground);
}

export { DEFAULT_COLORS };
